import { CommonEnums } from '../common.enums';
import { Design } from '../models/domain/design';
import { DxMp } from '../models/domain/dxmp';

export class ListUtil {
    private static instance: ListUtil;

    static getInstance() {
        if (!ListUtil.instance) {
            ListUtil.instance = new ListUtil();
        }

        return ListUtil.instance;
    }

    /**
    * ListUtil is a singleton class, so use ListUtil.getInstance() method instead of creating new ListUtil().
    */
    private constructor() {

    }

    splice(list: Array<any>): void {
        if (list.length == 0) return;

        list.splice(0, list.length);
    }

    copy(array: Array<any>): Array<any> {
        let arrayTmp: Array<any> = new Array<any>();

        for (let i: number = 0; i < array.length; i++) {
            arrayTmp.push(array[i]);
        }

        return arrayTmp;
    }

    copyFrom(array: Array<any>, arrayTmp: Array<any>): void {
        this.splice(array);

        for (let i: number = 0; i < arrayTmp.length; i++) {
            array.push(array[i]);
        }
    }

    // ----------------
    getItem(obj_Id, items) {
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item.obj_Id == obj_Id) return item;
        }
        return null;
    }

    addItem(object: any, item: any, obj_Cd: any) {
        let gridItems: Array<any> = new Array<any>();
        if (obj_Cd == CommonEnums.codes.REPCONN) {
            gridItems = object.connObjects;
        }
        else if (obj_Cd == CommonEnums.codes.DATAOBJECT) {
            gridItems = object.dObjObjects;
        }
        else if (obj_Cd == CommonEnums.codes.DESIGN) {
            gridItems = this.addDesignObject(object, item);
        }
        else if (obj_Cd == CommonEnums.codes.STREAM) {
            gridItems = object.streamObjects
        }
        else if (obj_Cd == CommonEnums.codes.DBSEQ) {
            gridItems = object.seqGridObjects
        }
        else if (obj_Cd == CommonEnums.codes.DBFUN) {
            gridItems = object.dBFunGridObjects
        }
        else if (obj_Cd == CommonEnums.codes.UDF) {
            gridItems = object.uDFGridObjects
        }

        let itemExist = this.getItem(item.obj_Id, gridItems);
        if (itemExist) {
            this.copyFromGridObject(itemExist, item)
            return;
        }

        item.recExists = false;
        gridItems.unshift(item);

        // if( object.itemsCount == -1 ) object.itemsCount++;
        // object.itemsCount++;
        // object.totalItemsCount++;
    }

    addDesignObject(object: any, design: DxMp) {
        if (design.reusableFlag == CommonEnums.reusableFlag.YES) {
            return object.dataSubFlowObjects;
        }
        if (design.streamingFlg == CommonEnums.streamingFlg.YES) {
            return object.dataStreamObjects;
        }
        if (design.streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
            return object.connectObjects;
        }
        return object.designGridObjects;
    }

    /**
     * 
     * @param gridObject 
     * @param objectCopy 
     */
    copyFromGridObject(gridObject, objectCopy) {
        gridObject.nm = objectCopy.nm;
        gridObject.change_Ind = objectCopy.change_Ind;
        gridObject.valid_Cd = objectCopy.valid_Cd;
        gridObject.recExists = objectCopy.recExists;
        gridObject.updateBy = objectCopy.updateBy;
        gridObject.updateDt = objectCopy.updateDt;

        if (objectCopy.obj_Cd == 'CONN') {
            if (objectCopy.repConn)
                gridObject.privateFlg = objectCopy.repConn.conn.privateFlg == "Y" ? 'Yes' : 'No';
            else
                gridObject.privateFlg = objectCopy.privateFlg;

            gridObject.owner_Nm = objectCopy.owner_Nm;
            gridObject.flagentNm = objectCopy.flagentNm;
            gridObject.aliasNm = objectCopy.aliasNm;
        }
    }
    deleteItem(object, obj_Id, selectedItems) {
        let deletedItems = [];
        for (let i = 0; i < object.items.length; i++) {
            let item = object.items[i];

            if (item.obj_Id == obj_Id) {
                object.itemsCount--;
                object.totalItemsCount--;
                let splicedItems = object.items.splice(i, 1);
                if (splicedItems.length > 0) deletedItems.push(splicedItems[0]);
                this.removeSelectedItem(obj_Id, selectedItems);
                break;
            }
        }
        return deletedItems;
    }

    removeSelectedItem(obj_Id, selectedItems) {
        for (let i = 0; i < selectedItems.length; i++) {
            let selectedItem = selectedItems[i];
            if (selectedItem.obj_Id == obj_Id) {
                selectedItems.splice(i, 1);
                break;
            }
        }
    }

}